import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./SubscribeButton.css";

class SubscribeButton extends Component {

  render() {
    return (
      <button
        className={classNames(styles.subscribe, this.props.className)}
        onClick={this.props.onClickSubscribe}
        disabled={this.props.disabled}
        alt="Subscribe">
        {this.props.children}
      </button>
    );
  }
}

SubscribeButton.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  onClickSubscribe: PropTypes.func,
  disabled: PropTypes.bool,
};

SubscribeButton.defaultProps = {
  disabled: false,
};

export default SubscribeButton;



// WEBPACK FOOTER //
// ./src/components/Library/SubscribeButton/SubscribeButton.js